export function flatMap(lambda) {
    return array =>
        Array.prototype.concat.apply([], array.map(lambda));
}

export function flow(actions) {
    return value =>
        actions.reduce((args, action) => action(args), value);
}

export function batchedExecute(callback, limit, scope) {
    const delayedArgs = [];
    let wait = false;
    let isFirst = true;
    const execute = () => {
        wait = false;
        isFirst = false;
        callback.call(scope, [].concat(delayedArgs));
        delayedArgs.length = 0;
    };
    return (...args) => {
        delayedArgs.push(args);
        if (!wait) {
            if (!isFirst) {
                execute();
            }
            wait = true;
            setTimeout(execute, limit);
        }
    };
}

export const skybetDiffusionName = (window.skybetDiffusionName || 'false').toUpperCase();




// WEBPACK FOOTER //
// ./lib/js/helpers/utils.js